import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21 3 9 15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 3H3v18h18v-9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 3h5v5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 15H9v-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Scaling";
const Scaling = memo(themed(Icon));
export {
  Scaling
};
//# sourceMappingURL=scaling.js.map
